module.exports = __webpack_public_path__ + "media/next_number_out_3.1aa1c2c6.mp3";